import React, {useState, useEffect, useRef} from "react"
import {Container} from "reactstrap"
import ReactPlayer from "react-player"
import gsap from "gsap"
import styled from "styled-components"
import Section from "../shared/Section"
import {media} from "utils/Media";
import {graphql, StaticQuery} from "gatsby";

const Section13 = styled(Section)`
 background-color: #000;
    z-index: 4;
    display: block;
    min-height: 40vw;
    overflow: hidden;

    .big {
        text-transform: uppercase;
        font-size: 24px;
        @media ${media.md} {
            font-size: 40px;
            text-transform: uppercase;
        }
    }
`

const Section12 = styled(Section)`
    background-color: #000;
    min-height: 40vw;
    overflow: hidden;
    //z-index: 4;
    position: relative;
    //top: 0;
    width: 100%;

    .videoWrap {
        position: absolute;
        left: 50%;
        top: -25%;
        /* transform: translateX(-50%); */
        width: 150%;
        height: 150%;
        pointer-events: none;
        z-index: 10;
    }
`
const SVGWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-end;
`

const Content = styled.div`

`
const Section13AdamSpiegelTablet = (props) => {
    const [playing, setPlaying] = useState(false);
    const player = useRef(null)

    useEffect(() => {
        gsap.timeline({
            scrollTrigger: {
                trigger: ".s12Md",
                scrub: true,
                start: "top top",
                end: "bottom top",
                scroller: ".scroller"
            }
        })
            .to(".s12Md", {yPercent: "-100"})

        gsap.timeline({
            scrollTrigger: {
                trigger: ".s12Md",
                scrub: true,
                start: "top top",
                end: "bottom top",
                scroller: ".scroller"
            }
        })
            .to(".svgWrapper3", {yPercent: "-30"})

        gsap.timeline({
            scrollTrigger: {
                trigger: ".s12Md",
                scrub: true,
                start: "top bottom",
                end: "bottom top",
                scroller: ".scroller",
                // onUpdate: self =>  this.player.seekTo(parseFloat(self.progress.toFixed(3))),
                onEnter: () => setPlaying(true),
                onEnterBack: () => setPlaying(true),
                onLeaveBack: () => setPlaying(false),
                onLeave: () => setPlaying(false)
            }
        })
            .fromTo(".video3Md", {yPercent: "-25", x: "-50%"}, {yPercent: "0", x: "-50%"})
            .to(".video3Md", {yPercent: "0", x: "-50%"})
            .to(".video3Md", {yPercent: "25", x: "-50%"})

        gsap.timeline({
            scrollTrigger: {
                trigger: ".s13Md",
                pin: true,
                scrub: true,
                start: "top top",
                scroller: ".scroller"
            }
        })
            .fromTo(".line2", {drawSVG: "0% 0%"}, {drawSVG: "0% 100%"}, 0.3)
            .fromTo(".line1", {drawSVG: "0% 0%"}, {drawSVG: "0% 100%"}, 0.4)
            .fromTo(".copy13Md", {opacity: "0"}, {opacity: "1"}, 0.5)
            .fromTo(".line3", {drawSVG: "0% 0%"}, {drawSVG: "0% 100%"}, 0.6)
            .fromTo(".line4", {drawSVG: "0% 0%"}, {drawSVG: "0% 100%"}, 0.7)
            .fromTo(".culprit2", {opacity: "0"}, {opacity: "1"}, 0.8)
            .fromTo(".adamMd", {opacity: "0"}, {opacity: "1"}, 0.9)
    }, [])

    return (
        <Section13 className="s13Md">
            <Section12 className="s12Md">
                <div className="video3Md videoWrap">
                    <ReactPlayer
                        ref={player}
                        url="//vimeo.com/454924328/f8c92c0fb3"
                        className="video"
                        width="100%"
                        height="100%"
                        muted={true}
                        controls={false}
                        playsinline={true}
                        playing={playing}
                        loop={true}
                        vimeo={{
                            fullscreen: 0
                        }}
                    />
                </div>
            </Section12>
            <Container className="svgWrapper3">
                <SVGWrapper>
                    <svg width="760" height="138" viewBox="0 0 760 138" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter13_ddd)">
                            <line className="line1" x1="13.5" y1="124.5" x2="748.5" y2="124.5" stroke="#FFAA00" strokeWidth="3" strokeLinecap="round"/>
                        </g>
                        <g filter="url(#filter13_ddd2)">
                            <line className="line2" x1="382.5" y1="13.5" x2="382.5" y2="124.5" stroke="#FFAA00" strokeWidth="3" strokeLinecap="round"/>
                        </g>
                        <defs>
                            <filter id="filter13_ddd" x="0" y="111" width="762" height="27.0001" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="6"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="3"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="2"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape"/>
                            </filter>
                            <filter id="filter13_ddd2" x="369" y="0" width="27" height="138" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="6"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="3"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="2"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape"/>
                            </filter>
                        </defs>
                    </svg>

                </SVGWrapper>
                <Content className="narrow">
                    <p className="copy13Md">On behalf of the entire team, thank you for reading, and we look forward to welcoming you to the wonderful world of Agatha Christie’s masterpiece,  THE MOUSETRAP.</p>
                </Content>

                <SVGWrapper>
                    <svg width="760" height="245" viewBox="0 0 760 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="culprit2" d="M423.844 133.734V132.304H415.154V133.734H418.718V147H420.28V133.734H423.844ZM432.758 147V141.368C432.758 140.136 432.604 139.476 432.208 138.926C431.702 138.2 430.668 137.716 429.634 137.716C428.71 137.716 427.852 138.068 427.214 138.706C427.126 138.794 426.994 138.926 426.84 139.124V130.236H425.366V147H426.84V142.534C426.84 140.048 427.544 138.992 429.216 138.992C429.986 138.992 430.69 139.3 430.976 139.806C431.196 140.18 431.284 140.708 431.284 141.5V147H432.758ZM443.361 142.688C443.339 140.906 443.009 139.828 442.129 138.926C441.381 138.112 440.303 137.694 439.093 137.694C436.497 137.694 434.671 139.674 434.671 142.512C434.671 145.328 436.453 147.264 439.049 147.264C440.787 147.264 442.217 146.362 443.031 144.756L441.887 144.14C441.073 145.394 440.237 145.922 439.093 145.922C437.443 145.922 436.277 144.602 436.233 142.688H443.361ZM441.799 141.412L436.321 141.456C436.673 139.872 437.663 138.97 439.071 138.97C440.545 138.97 441.579 139.894 441.799 141.412ZM457.879 146.472V144.734C456.911 145.592 456.185 145.878 455.151 145.878C453.193 145.878 451.873 144.514 451.873 142.512C451.873 140.466 453.215 139.058 455.129 139.058C456.163 139.058 456.911 139.366 457.835 140.202V138.464C456.999 137.914 456.207 137.672 455.173 137.672C452.467 137.672 450.333 139.784 450.333 142.49C450.333 145.196 452.445 147.264 455.173 147.264C456.185 147.264 456.933 147.044 457.879 146.472ZM467.323 143.458V137.936H465.849V143.216C465.849 145.042 465.189 145.856 463.693 145.856C462.153 145.856 461.493 145.042 461.493 143.216V137.936H460.019V143.458C460.019 144.668 460.283 145.526 460.877 146.142C461.559 146.846 462.571 147.264 463.671 147.264C464.771 147.264 465.827 146.846 466.465 146.142C467.059 145.482 467.323 144.668 467.323 143.458ZM471.508 147V130.236H470.034V147H471.508ZM483.351 142.49C483.351 139.674 481.525 137.65 478.995 137.65C477.653 137.65 476.641 138.156 475.717 139.3V137.936H474.243V152.236H475.717V145.548C476.707 146.736 477.697 147.242 479.039 147.242C481.525 147.242 483.351 145.24 483.351 142.49ZM481.855 142.468C481.855 144.47 480.535 145.944 478.753 145.944C476.905 145.944 475.607 144.514 475.607 142.49C475.607 140.4 476.905 138.948 478.753 138.948C480.535 138.948 481.855 140.422 481.855 142.468ZM490.413 138.068C489.841 137.76 489.555 137.672 489.071 137.672C488.081 137.672 487.311 138.178 486.761 139.19V137.848H485.265V147H486.761V142.248C486.761 140.532 487.069 139.74 487.883 139.3C488.169 139.168 488.477 139.08 488.785 139.08C489.203 139.08 489.357 139.146 489.731 139.366L490.413 138.068ZM493.953 134.108C493.953 133.514 493.469 133.03 492.875 133.03C492.281 133.03 491.797 133.514 491.797 134.108C491.797 134.702 492.281 135.186 492.875 135.186C493.469 135.186 493.953 134.702 493.953 134.108ZM493.623 147V137.936H492.127V147H493.623ZM499.841 139.322V137.958H498.147V134.526H496.695V137.958H495.903V139.322H496.695V147H498.147V139.322H499.841ZM509.293 134.108C509.293 133.514 508.809 133.03 508.215 133.03C507.621 133.03 507.137 133.514 507.137 134.108C507.137 134.702 507.621 135.186 508.215 135.186C508.809 135.186 509.293 134.702 509.293 134.108ZM508.963 147V137.936H507.467V147H508.963ZM517.49 144.338C517.49 143.524 517.16 142.864 516.478 142.38C516.06 142.072 515.752 141.918 514.718 141.478C513.508 140.95 513.2 140.664 513.2 140.092C513.2 139.476 513.728 138.992 514.366 138.992C514.894 138.992 515.334 139.278 515.642 139.85L516.786 139.256C516.302 138.222 515.51 137.694 514.432 137.694C512.958 137.694 511.836 138.772 511.836 140.202C511.836 140.906 512.122 141.522 512.628 141.918C513.002 142.182 513.2 142.292 514.476 142.864C515.686 143.436 516.016 143.766 516.016 144.448C516.016 145.328 515.334 145.966 514.432 145.966C513.86 145.966 513.332 145.724 513.002 145.306C512.848 145.108 512.782 145.02 512.584 144.602L511.374 145.13C511.858 146.516 512.936 147.286 514.388 147.286C516.148 147.286 517.49 146.01 517.49 144.338ZM522.171 146.164C522.171 145.614 521.709 145.152 521.137 145.152C520.565 145.152 520.103 145.614 520.103 146.164C520.103 146.736 520.565 147.198 521.137 147.198C521.709 147.198 522.171 146.736 522.171 146.164ZM528.015 146.164C528.015 145.614 527.553 145.152 526.981 145.152C526.409 145.152 525.947 145.614 525.947 146.164C525.947 146.736 526.409 147.198 526.981 147.198C527.553 147.198 528.015 146.736 528.015 146.164ZM533.859 146.164C533.859 145.614 533.397 145.152 532.825 145.152C532.253 145.152 531.791 145.614 531.791 146.164C531.791 146.736 532.253 147.198 532.825 147.198C533.397 147.198 533.859 146.736 533.859 146.164Z" fill="white"/>
                        <g filter="url(#filter13_ddd3)">
                            <line className="line3" x1="13.5" y1="13.5" x2="748.5" y2="13.5001" stroke="#FFAA00" strokeWidth="3" strokeLinecap="round"/>
                        </g>
                        <g filter="url(#filter13_ddd4)">
                            <line className="line4" x1="382.5" y1="16.5" x2="382.5" y2="231.5" stroke="#FFAA00" strokeWidth="3" strokeLinecap="round"/>
                        </g>
                        <defs>
                            <filter id="filter13_ddd3" x="0" y="0" width="762" height="27.0001" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="6"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="3"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="2"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape"/>
                            </filter>
                            <filter id="filter13_ddd4" x="369" y="3" width="27" height="242" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="6"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="3"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="2"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.234375 0 0 0 0 0 0 0 0 1 0"/>
                                <feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape"/>
                            </filter>
                        </defs>
                    </svg>

                </SVGWrapper>
                <p className="adamMd big text-center text-uppercase">Adam Spiegel, Producer</p>
            </Container>
        </Section13>
    )
}

export default () => (
    <StaticQuery
        query={graphql`
            query {
                woodBg: file(relativePath: { eq: "wood-bg.jpg" }) {
                    childImageSharp {
                        fluid(maxWidth: 1920, quality: 85) {
                            ...GatsbyImageSharpFluid_withWebp
                        }
                    }
                }
            }
		`}
        render={data => (
            <Section13AdamSpiegelTablet data={data}/>
        )}
    />
)
